import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { api } from "../api";
import Error from "./Error/Error";
import Loading from "./Loading";

const SURVEY_REQUIRED_VIDEO_ID = process.env.REACT_APP_SURVEY_REQUIRED_VIDEO_ID
    ? Number(process.env.REACT_APP_SURVEY_REQUIRED_VIDEO_ID)
    : 2;


const RequireSurveyAccess = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const { t } = useTranslation();

    useEffect(() => {
        const checkAccess = async () => {
            try {
                const videos = await api.get("/videos");
                const surveyVideo = (videos || []).find(v => v.id === SURVEY_REQUIRED_VIDEO_ID);
                if (!surveyVideo) {
                    setError(t("survey.no_access"));
                    return;
                }
                if (!surveyVideo.completed) {
                    setError(t("survey.complete_video_first"));
                    return;
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        checkAccess();
    }, [t]);

    if (error) return <Error message={error} />;
    if (loading) return <Loading />;
    return children;
};

export default RequireSurveyAccess;
